import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import EditIcon from "@material-ui/icons/Edit";
import { isBlank, notBlank } from "../util/ext";
import { Link, useRouteMatch, useHistory } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { find, map, not, propEq } from "ramda";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { useOrganizations } from "../user-admin/userServices";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
  },

  contentCell: {
    width: "33%",
  },

  cell: {
    minWidth: 135,
  },
}));

const ProgramTable = ({ programs, onScrollVisible }) => {
  const { url } = useRouteMatch();
  const history = useHistory();
  const classes = useStyles();

  const [libraries, setLibraries] = useState([]);
  const libraryResponse = useOrganizations();
  useEffect(() => {
    if (libraryResponse.isSuccess) {
      setLibraries(libraryResponse.data);
    }
  }, [libraryResponse.isSuccess, libraryResponse.data]);

  //-- Track if the scroll bar is visible
  const tableContainerEl = useRef(null);
  useEffect(() => {
    if (notBlank(tableContainerEl)) {
      const element = tableContainerEl.current;
      const scrollVisible = element.scrollHeight > element.clientHeight;
      onScrollVisible(scrollVisible);
    }
  }, [onScrollVisible, tableContainerEl]);

  const findOrganization = organizationId => {
    const organization = find(
      propEq("organizationId", organizationId),
      libraries,
    );

    return (
      <Typography color={not(organization.active) ? "error" : "inherit"}>
        {organization.organizationName}
      </Typography>
    );
  };

  const handleRowClick = programId => event => {
    history.push(`${url}/${programId}`, {
      label: "Back to All Progams",
      previousLocation: "/manage-csp/programs",
    });
  };

  return (
    <Paper elevation={0} className={classes.root}>
      <TableContainer
        ref={tableContainerEl}
        style={{ height: "calc(100vh - 350px)" }}
      >
        <Table stickyHeader aria-label="Programs">
          <TableHead>
            <TableRow>
              <TableCell
                key="program"
                align="left"
                className={classes.contentCell}
              >
                Name
              </TableCell>

              <TableCell
                key="program_key"
                align="left"
                className={classes.cell}
              >
                Program Key
              </TableCell>

              <TableCell
                key="organization"
                align="left"
                className={classes.cell}
              >
                Organization
              </TableCell>

              <TableCell
                key="actions-edit"
                align="center"
                style={{ width: 50 }}
              >
                Edit
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {map(
              program => (
                <TableRow
                  onClick={handleRowClick(program.programId)}
                  style={{ cursor: "pointer" }}
                  hover
                  tabIndex={-1}
                  key={program.programId}
                >
                  <TableCell
                    key={"name:" + program.programId}
                    align="left"
                    className={classes.contentCell}
                  >
                    {program.programName}
                  </TableCell>

                  <TableCell
                    key={"key:" + program.programId}
                    align="left"
                    className={classes.contentCell}
                  >
                    {program.programKey}
                  </TableCell>

                  <TableCell
                    key={"organization:" + program.programId}
                    align="left"
                  >
                    {isBlank(libraries) ? (
                      <Skeleton variant="text" />
                    ) : (
                      notBlank(program.organizationId) &&
                      findOrganization(program.organizationId)
                    )}
                  </TableCell>

                  <TableCell
                    key={"actions-edit:" + program.programId}
                    align="center"
                    style={{ width: 50 }}
                  >
                    <Tooltip title="Edit">
                      <Link
                        to={{
                          pathname: `${url}/${program.programId}`,
                          state: {
                            label: "Back to All Programs",
                            previousLocation: "/manage-csp/programs",
                          },
                        }}
                      >
                        <EditIcon fontSize="large" color="primary" />
                      </Link>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ),
              programs,
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ProgramTable;
